import { Link } from 'react-router-dom';

export function CancelPage() {
  return (
    <div className="container">
      <div className="card checkout-panel">
        <div className="status-icon warn">
          <span className="material-symbols-outlined">shopping_cart_off</span>
        </div>
        <h1>Checkout canceled</h1>
        <p>No worries, partner — be a goldfish. Nothing was charged. The Marketplace is ready when you are.</p>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link className="btn btn-primary" to="/marketplace">
            Return to Marketplace
          </Link>
          <Link className="btn btn-ghost" to="/">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
